import { useState } from 'react';
import { errorToast, successToast } from '@components/toasts/Toasts';
import { ApiError } from '@shared/api/errors';
import { reportAppError } from '@shared/reportAppError';
import { updateStaffNote } from '../../reservations/apiHelpers';
import { useRestaurant } from '../../context/useRestaurant';
import type { StaffNoteEditFormOnSaveArgs } from './StaffNoteEditForm/StaffNoteEditForm';
import { StaffNoteEditForm } from './StaffNoteEditForm/StaffNoteEditForm';
import { StaffNoteShow } from './StaffNoteShow/StaffNoteShow';

export interface StaffNoteProps {
  reservationId: string;
  staffNote: string | null;
  onUpdate?: () => void;
  className?: string;
}

export const StaffNote = ({
  reservationId,
  staffNote,
  onUpdate,
  className,
}: StaffNoteProps) => {
  const [isEditFormVisible, setIsEditFormVisible] = useState(false);
  const [currentNote, setCurrentNote] = useState(staffNote);
  const { id: restaurantId } = useRestaurant();

  const handleSave = ({
    note: staffNoteContent,
  }: StaffNoteEditFormOnSaveArgs): void => {
    void (async () => {
      let updated = false;
      try {
        await updateStaffNote({
          restaurantId,
          reservationId,
          staffNote: staffNoteContent,
        });
        updated = true;
      } catch (e) {
        if (e instanceof ApiError) {
          errorToast({ message: e.message });
        }
        reportAppError(e);
      }

      if (updated) {
        setCurrentNote(staffNoteContent);
        setIsEditFormVisible(false);
        successToast({ message: 'Staff note saved successfully' });
        onUpdate?.();
      }
    })();
  };

  return isEditFormVisible ? (
    <StaffNoteEditForm
      className={className}
      note={currentNote}
      onDiscard={() => {
        setIsEditFormVisible(false);
      }}
      onSave={handleSave}
    />
  ) : (
    <StaffNoteShow
      className={className}
      note={currentNote}
      onEdit={() => setIsEditFormVisible(true)}
    />
  );
};
